import { withInstall, withNoopInstall } from '@sgui-plus/utils'
import Table from './src/table.vue'
import TableColumn from './src/tableColumn'

export const SgTable = withInstall(Table, {
  TableColumn,
})
export default SgTable
export const SgTableColumn = withNoopInstall(TableColumn)

export type TableInstance = InstanceType<typeof Table>

export type TableColumnInstance = InstanceType<typeof TableColumn>

export type {
  SummaryMethod,
  Table,
  TableProps,
  TableRefs,
  ColumnCls,
  ColumnStyle,
  CellCls,
  CellStyle,
  TreeNode,
  RenderRowData,
  Sort,
  Filter,
  TableColumnCtx,
} from './src/table/defaults'
